import { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { usePaywallCheckoutContext } from "@/react/contexts/Paywalls/paywallCheckoutContext";
import { isPix } from "@circle-react/helpers/paywallCheckoutHelpers";
import { useGetCouponApplication } from "../../../hooks/useGetCouponApplication";
import type { CheckoutFormValuesProps } from "../../../types/CheckoutFormValuesProps";

export const useIsPaymentElementRequired = () => {
  const { watch } = useFormContext<CheckoutFormValuesProps>();
  const { paywall, getSelectedPrice, couponPreviewMutation } =
    usePaywallCheckoutContext();

  const selectedPrice = getSelectedPrice();
  const isPixEnabled = isPix(watch("payment_method_type"));
  const couponApplication = useGetCouponApplication(
    selectedPrice.id,
    couponPreviewMutation,
  );

  return useMemo(
    () =>
      (!selectedPrice.trial_enabled ||
        selectedPrice.trial_requires_upfront_payment ||
        paywall.trial_requires_card) &&
      !isPixEnabled &&
      !couponApplication?.free_forever,
    [paywall, selectedPrice, isPixEnabled, couponApplication?.free_forever],
  );
};
